<template>
    <div class="order-detail-chat" data-automation="OrderDetailChat">
        <!-- 聊天记录 -->
        <order-detail-chat-list
            :list="msgList"
            :is-user="isUser"
            :orderStatus="orderInfo.order_status"
            @over-order="$emit('over-order')"
        ></order-detail-chat-list>

        <!-- 文本框 -->
        <order-detail-textarea
            v-if="$hasModule(80)"
            :is-user="isUser"
            :is-expansion="isExpansion"
            :order-info="orderInfo"
            :orderStatus="orderInfo.order_status"
            @change-expansion="changeExpansion"
            @refresh="refresh"
            @over-order="$emit('over-order')"
        ></order-detail-textarea>
    </div>
</template>

<script>
import orderDetailChatList from './orderDetailChatList';
import orderDetailTextarea from './orderDetailTextarea';

export default {
  name: 'OrderDetailChat',
  components: {
    orderDetailChatList,
    orderDetailTextarea
  },
  props: {
    // 基础信息
    orderInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 聊天记录
    msgList: {
      type: Array,
      default: []
    },
    // 展开全部
    isExpansion: {
      type: Boolean,
      default: false
    },
    isUser: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
    };
  },
  computed: {
    // 已经关闭
    isOver() {
      return String(this.orderInfo.order_status) === '3';
    }
  },
  methods: {
    changeExpansion() {
      this.$emit('change-expansion');
    },
    refresh() {
      this.$emit('refresh');
    }
  }
};
</script>

<style lang="scss" scoped>
.order-detail-chat {
    border-radius: 16px;
    position: relative;
    background: #fff;
    min-height: 550px;
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;

    .order-detail-chat-list {
        flex: 1;
    }

    .order-detail-textarea {
        width: 100%;
        flex: 0 0 auto;
        padding: 0 24px 24px;
        max-height: 480px;
    }
}
</style>
